import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import {
  COMPANY_MODAL_ACTION_TYPE,
  CONSULTATION_MODAL_ACTION_TYPE,
} from "../../../redux/actions-type";
import moment from "moment";
import { deleteConsultationAction } from "../../../redux/actions/consultationsActions";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import { RiUpload2Fill } from "react-icons/ri";
import { RiDownload2Fill } from "react-icons/ri";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Box, Typography } from "@mui/material";
import {
  deleteConmpanyAdditionalContractAction,
  deleteConmpanyContractAction,
  downloadCompanyAdditionalContractAction,
  downloadCompanyContractAction,
  uploadCompanyAdditionalContractAction,
  uploadCompanyContractAction,
} from "../../../redux/actions/companiesActions";

const CompanyCard = ({
  cellNumber,
  mode,
  setOpenMoreModal,
  data,
  consultation,
}) => {
  const dispatch = useDispatch();
  const { contractTypesList } = useCustomHook();
  const fileInputRef = useRef(null);
  const additionalFileInputRef = useRef(null);

  const updateItem = () => {
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.GET_COMPANY_MODAL,
      payload: {
        data: data,
        openModal: true,
      },
    });
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadCompanyContractAction(data._id, formData));
  };

  const handleUploadAdditionalContract = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadCompanyAdditionalContractAction(data._id, formData));
  };

  const doubleClick = () => {
    updateItem("");
  };

  return (
    <tr onDoubleClick={doubleClick}>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {cellNumber}. {data?.companyName}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.directorFullName}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.companyVoen}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankName}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.correspondentAccount}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankVoen}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankCode}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.swift}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.settlementAccount}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {contractTypesList.find(
              (item) => item.key === data?.contract?.contractType,
            )?.name || ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {" "}
            {data?.contractEndDate
              ? moment(data.contractStartDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {" "}
            {data?.contractEndDate
              ? moment(data.contractEndDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {data?.paymentDate
              ? moment(data.paymentDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.payment}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          <input
            type="file"
            accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ref={additionalFileInputRef}
            onChange={handleUploadAdditionalContract}
            style={{ display: "none" }}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {data?.additionalContracts?.map((file) => (
              <Box
                sx={{
                  width: "100%",
                  gap: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid gray",
                  padding: "2px",
                  boxSizing: "border-box",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  fontSize={12}
                  sx={{
                    color: "green",
                    textTransform: "initial",
                  }}
                >
                  {file?.slice(0, 19) + ".docx"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <RiDownload2Fill
                    fill="#462aff"
                    style={{
                      cursor: "pointer",
                      padding: 1,
                      boxSizing: "border-box",
                      fontSize: 24,
                    }}
                    onClick={() => {
                      dispatch(
                        downloadCompanyAdditionalContractAction(data, {
                          fileName: file,
                        }),
                      );
                    }}
                  />
                  <MdOutlineDeleteOutline
                    fill="rgb(237, 68, 78)"
                    style={{
                      cursor: "pointer",
                      padding: 1,
                      boxSizing: "border-box",
                      fontSize: 24,
                    }}
                    onClick={() => {
                      dispatch(
                        deleteConmpanyAdditionalContractAction(data._id, {
                          fileName: file,
                        }),
                      );
                    }}
                  />
                </Box>
              </Box>
            ))}
            <Box
              sx={{
                width: "100%",
                gap: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  fontSize={12}
                  sx={{
                    color: "gray",
                    textTransform: "initial",
                  }}
                >
                  Fayl əlavə et
                </Typography>
                <RiUpload2Fill
                  fill="gray"
                  style={{
                    cursor: "pointer",
                    padding: 1,
                    boxSizing: "border-box",
                    fontSize: 24,
                  }}
                  onClick={() => additionalFileInputRef.current.click()}
                />
              </Box>
            </Box>
          </Box>
        </div>
      </td>
      <td>
        <div className="td-con">
          <input
            type="file"
            accept="application/pdf"
            ref={fileInputRef}
            onChange={handleUpload}
            style={{ display: "none" }}
          />
          {data?.signedContractPath && (
            <Box
              sx={{
                width: "100%",
                gap: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                fontSize={12}
                sx={{
                  color: "green",
                  textTransform: "initial",
                }}
              >
                {data?.signedContractPath
                  ? data.signedContractPath?.slice(0, 15) + ".pdf"
                  : "Fayl mövcud deyil"}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <RiDownload2Fill
                  fill="#462aff"
                  style={{
                    cursor: "pointer",
                    padding: 1,
                    boxSizing: "border-box",
                    fontSize: 24,
                  }}
                  onClick={() => {
                    dispatch(downloadCompanyContractAction(data));
                  }}
                />
                <MdOutlineDeleteOutline
                  fill="rgb(237, 68, 78)"
                  style={{
                    cursor: "pointer",
                    padding: 1,
                    boxSizing: "border-box",
                    fontSize: 24,
                  }}
                  onClick={() => {
                    dispatch(deleteConmpanyContractAction(data._id));
                  }}
                />
              </Box>
            </Box>
          )}
          {!data?.signedContractPath && (
            <Box
              sx={{
                width: "100%",
                gap: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  fontSize={12}
                  sx={{
                    color: "gray",
                    textTransform: "initial",
                  }}
                >
                  Fayl əlavə et
                </Typography>
                <RiUpload2Fill
                  fill="gray"
                  style={{
                    cursor: "pointer",
                    padding: 1,
                    boxSizing: "border-box",
                    fontSize: 24,
                  }}
                  onClick={() => fileInputRef.current.click()}
                />
              </Box>
            </Box>
          )}
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {data?.isActive ? "Aktiv" : "Deaktiv"}
          </div>
        </div>
      </td>
      <td>
        <UpdateDeleteModal
          updateItem={updateItem}
          data={data}
          openConfirmModal={() => {}}
          profil={"company"}
          state={consultation}
          setShowDeleteModal={() => {}}
        />
      </td>
    </tr>
  );
};

export default CompanyCard;
